import { Component, Vue, Prop } from 'vue-property-decorator';
import { RequestViewType } from '@/views/Requests/Requests.ts';

@Component<RequestButtonKanbanBoard>({})
export default class RequestButtonKanbanBoard extends Vue {
  @Prop()
  protected value!: RequestViewType;

  protected buttonViewType: RequestViewType = 'kanban';

  protected handleClick(): void {
    this.$emit('input', this.buttonViewType);
  }

  protected get isActive(): boolean {
    return this.value === this.buttonViewType;
  }
}
